import { render, staticRenderFns } from "./SettingsClientDropdown.vue?vue&type=template&id=1991a23f&scoped=true&lang=pug&"
import script from "./SettingsClientDropdown.vue?vue&type=script&lang=js&"
export * from "./SettingsClientDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SettingsClientDropdown.vue?vue&type=style&index=0&id=1991a23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991a23f",
  null
  
)

export default component.exports